'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { AssetField } from '@/lib/asset'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxImageHolder } from './ImageHolder'

interface ImageHolderBlokProps {
  blok: {
    asset: AssetField
    width: number
    layout: string
  } & SbBlokData
}

const ImageHolder: FC<ImageHolderBlokProps> = ({ blok }) => {
  const [imagesSet, setImagesSet] = useState<AssetField | null>(null)

  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)

  useEffect(() => {
    setImagesSet(blok.asset)
  }, [blok.asset])

  return (
    <div {...storyblokEditable(blok)}>
      {imagesSet && (
        <PhnxImageHolder
          key={imagesSet.filename}
          images={[
            {
              src: imagesSet.filename ? imagesSet.filename : '',
              alt: imagesSet.alt ? imagesSet.alt : '',
              focus: imagesSet.focus,
            },
          ]}
          maxWidthPercentage={blok.width ? blok.width : 100}
          layout={blok.layout}
          textColor={stylePanel.textColor}
          backgroundColor={stylePanel.backgroundColor}
          padding={stylePanel.padding}
          alignment={stylePanel.alignment}
        />
      )}
    </div>
  )
}

export default ImageHolder
